import { useSelector } from 'react-redux';
import { WARootState } from '@/store/store';

/**
 * Hook that returns whether authentication is currently loaded
 * @returns {boolean} True if auth token is loaded, false otherwise
 * @example
 * ```tsx
 * function MyComponent() {
 *   const authIsLoaded = useAuthIsLoaded();
 *
 *   if (!authIsLoaded) {
 *     return <LoadingSpinner />;
 *   }
 *
 *   return <div>Content</div>;
 * }
 * ```
 */

export const useAuthIsLoaded = () => {
  const authToken = useSelector(
    (state: WARootState) => state.appView.UserInfo?.Token,
  );

  return !!authToken;
};
